/**
 * Feature Flag constants
 *
 * This file contains all feature flag names used throughout the application.
 * Always use these constants instead of hardcoding strings to ensure consistency
 * and avoid typos.
 *
 * Note: All feature flag names are stored as lowercase with underscores replacing spaces
 * Example: "My Feature" is stored as "my_feature"
 */

export const FEATURE_FLAGS = {
  FIRST_TEST: 'first_ff_for_test',
  SHOW_RECURRENT_EVENTS_FOR_BETA_USERS: 'show_recurrent_events_for_beta_users',
  SHOW_RECURRENT_EVENTS_FOR_ALL_USERS: 'show_recurrent_events_for_all_users',
  NEW_CATEGORY_SPOTLIGHT: 'new_category_spotlight',
  NEW_CATEGORY_SPOTLIGHT_FOR_BETA_USERS: 'new_category_spotlight_for_beta_users',
  SHOW_RPM_HELP_CENTER_BUTTON: 'show_rpm_help_center_button',
  FEATURE_GLOBAL_DISMISSIBLE_BANNER: 'feature_global_dismissible_banner',
  FEATURE_GLOBAL_STATIC_BANNER: 'feature_global_static_banner',
} as const;

// Type-safe access to feature flag names
export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
export type FeatureFlagName = (typeof FEATURE_FLAGS)[FeatureFlagKey];
